<app-modal
  (closeModal)="onClose()"
  [title]="(deliveryModalTitle$ | async) || ''"
>
  <div class="delivery-type-form" *ngIf="settings$ | async as settings">
    <div class="delivery-type-form__head" *ngIf="settings.isProvidingCollection && settings.isProvidingDelivery">
      <app-switcher
        [formControl]="switchControl"
        [values]="[deliveryTypes.Delivery, deliveryTypes.Pickup]"
        (changeValue)="onChangeOrderType($event)"
      >
        <span class="h4 switcher-btn" i18n="@@Delivery" leftTitle>Delivery</span>
        <span class="h4 switcher-btn" i18n="@@DeliveryByClient" rightTitle>Pickup</span>
      </app-switcher>
    </div>
    <div class="delivery-type-form__body"
         *ngIf="{selectedDeliveryType: selectedDeliveryType$ | async, deliveryAddress: deliveryAddress$ | async} as data"
    >
      <app-address-selector [isFullView]="false" [formControl]="addressControl" *ngIf="data.selectedDeliveryType"></app-address-selector>
    </div>
  </div>

  <ng-container footer *ngIf="selectedDeliveryType$ | async as selectedDeliveryType">
    <button
      type="button"
      class="button button--th-main _rounded modal-footer-button"
      (click)="onConfirmPickup()"
      *ngIf="selectedDeliveryType === deliveryTypes.Pickup"
    >
      <span i18n="@@ButtonPickupHere" >I'll pick up here</span>
    </button>
    <button
      type="button"
      class="button button--th-main _rounded modal-footer-button"
      (click)="onConfirmDeliveryAddress()"
      *ngIf="selectedDeliveryType === deliveryTypes.Delivery"
      [disabled]="addressControl.invalid"
    >
      <span i18n="@@ButtonDeliverHere">Deliver here</span>
    </button>
  </ng-container>
</app-modal>

